import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { DynamicBarService } from '../_components/dynamic-bar/dynamic-bar.service';
import { AccountService } from '../_services/account.service';
import { Subscription } from 'rxjs';
import { HomeService } from './home.service';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { Router } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'home',
  standalone: false,
  templateUrl: 'home.component.html',
  styleUrls: ['./home.component.scss', '../user/card/card.component.scss'],
  host: {
    '(document:click)': 'offClick($event)',
  }
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChildren(MatMenuTrigger) menuTriggers!: QueryList<MatMenuTrigger>;
  @ViewChild('columnsContainer', { static: false }) columnsContainer!: ElementRef;

  loggedUser: any;
  homeSubscriber!: Subscription;
  materias: any[] = [];
  columnsMaterias: any;
  notificaciones: any[] = [];
  hijos: any[] | null = null;
  loadingData = true;
  alumno: any;
  columnas: any[] = [];
  numColumnas = 1;
  anchoFicha!: number;
  anchoColumnas: any;
  overlay = false;
  overlayHeight = '100%';

  constructor(
    private san: DomSanitizer,
    private titleService: Title,
    private dynamicBarService: DynamicBarService,
    private accountService: AccountService,
    private homeService: HomeService,
    private customAlertService: CustomAlertService,
    private router: Router
  ) {}

  ngOnInit() {
    this.dynamicBarService.setBarra('home-barra');
    this.titleService.setTitle('Página de inicio - MiGLM');

    this.loggedUser = this.accountService.getPersona();

    this.homeSubscriber = this.homeService.getHome().subscribe(
      (res) => {
        const data = this.homeService.extractData(res);
        this.materias = data.hasOwnProperty('materias') && data.materias && data.materias.length > 0 ? data.materias : [];
        this.columnas = this.getColumnas(this.materias);
        this.notificaciones = data.hasOwnProperty('notificaciones') && data.notificaciones && data.notificaciones.length > 0 ? data.notificaciones : [];
        this.hijos = data.hasOwnProperty('hijos') && data.hijos && data.hijos.length > 0 ? data.hijos : null;
        this.alumno = data.hasOwnProperty('alumno') && data.alumno ? data.alumno : null;
        this.loadingData = false;
      },
      (err) => {
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No se ha podido cargar la información inicial. ${err.error} <br> Código de error: ${err.statusText}`
        });
      }
    );
  }

  ngOnDestroy() {
    if (this.homeSubscriber) {
      this.homeSubscriber.unsubscribe();
    }
  }

  openMenu(event: MouseEvent, menuTrigger: MatMenuTrigger): void {
    if ((event.target as HTMLElement).closest('.menu-button')) {
      return;
    }
    
    if (menuTrigger) {
      menuTrigger.openMenu();
      event.stopPropagation();
    }
  }

  navigate(link: any): void {
    if (link.isExterno) {
      window.open(link.url, '_blank');
    } else {
      this.router.navigate(['/'].concat(link.url.split('/')));
    }
  }

  openLink(url: string): void {
    window.open(url, '_blank');
  }

  getColumnas(elements: any[]): any[] {
    const columns = [];
    this.createColumns();
    for (let i = 0; i < this.numColumnas; i++) {
      columns[i] = { els: [] };
    }
    if (columns.length > 0 && elements && elements.length > 0) {
      columns.forEach((col) => (col.els = []));
      elements.forEach((materia, i) => {
        columns[i % this.numColumnas].els.push(materia);
      });
    }
    return columns;
  }

  createColumns(): void {
    const containerWidth = (this.columnsContainer.nativeElement as HTMLElement).offsetWidth;
    const ancho = containerWidth < 360 ? containerWidth - 24 : 360;
    this.numColumnas = Math.floor(window.innerWidth / ancho) === 0 ? 1 : Math.floor(containerWidth / ancho);
    this.anchoFicha = (containerWidth - 64) / this.numColumnas;
    this.anchoColumnas = this.san.bypassSecurityTrustStyle(`calc(100% / ${this.numColumnas})`);
  }

  offClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (target.classList.contains('custom-overlay')) {
      this.overlay = false;
      if (this.columnas && this.columnas.length > 0) {
        this.columnas.forEach((col) => {
          col.els.forEach((materia: any) => {
            if (materia.items) {
              materia.items.forEach((item: any) => {
                if (item && item.hasOwnProperty('detalle')) {
                  item.detalle = null;
                }
              });
            }
          });
        });
      }
      if (this.hijos && this.hijos.length > 0) {
        this.hijos.forEach((hijo) => {
          if (hijo.materias) {
            hijo.materias.forEach((materia: any) => {
              if (materia.items) {
                materia.items.forEach((item: any) => {
                  if (item.hasOwnProperty('detalle')) {
                    item.detalle = null;
                  }
                });
              }
            });
          }
        });
      }
    }
  }

  setOverlay(data: boolean): void {
    this.overlay = data;
  }
  
}